import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  signal,
  ViewEncapsulation,
} from '@angular/core';

import { MapComponent, MarkerComponent } from 'ngx-mapbox-gl';
import { Location } from '@clientwire/api';
import { InViewportModule } from 'ng-in-viewport';
import { AppTypeService } from '../../../../services/app-type.service';

@Component({
  selector: 'shared-message-map',
  imports: [InViewportModule, MapComponent, MarkerComponent],
  templateUrl: './message-map.component.html',
  styleUrl: './message-map.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageMapComponent {
  public centerCoordinates: InputSignal<Location> = input.required<Location>();
  readonly visible = signal<boolean>(false);

  private readonly appTypeService = inject(AppTypeService);

  // Enable cooperative gestures for client app (require Ctrl/⌘ to scroll zoom)
  readonly cooperativeGestures = computed(() => this.appTypeService.type() === 'client');

  public onIntersection({ visible }: { target: Element; visible: boolean }): void {
    this.visible.set(visible);
  }
}
